import { render } from "./Breadcrumbs.vue?vue&type=template&id=46e126d0"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"

import "./Breadcrumbs.vue?vue&type=style&index=0&id=46e126d0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Breadcrumbs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46e126d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46e126d0', __exports__)) {
    api.reload('46e126d0', __exports__)
  }
  
  module.hot.accept("./Breadcrumbs.vue?vue&type=template&id=46e126d0", () => {
    api.rerender('46e126d0', render)
  })

}


export default __exports__